<script setup lang="ts">
import VideoPlayer from '../components/VideoPlayer.vue'
import ProjectCarousel from '../components/ProjectCarousel.vue'
import { projectsData } from '../data/projects'
</script>

<template>
  <main id="work" class="w-full min-h-screen relative z-30">
    <!-- Dark background with top trapezoid -->
    <div class="absolute inset-0 bg-[#151515]">
      <div
        class="absolute -top-[60px] left-0 w-full h-[60px]"
        style="clip-path: polygon(0 100%, 100% 0, 100% 100%)"
      >
        <div class="w-full h-full bg-[#151515]"></div>
      </div>
    </div>

    <div class="relative pt-[120px] pb-[100px] md:pt-[250px] max-w-[1300px] mx-auto">
      <!-- Mobile Carousel -->
      <div class="block md:hidden">
        <ProjectCarousel :projects="projectsData" />
      </div>

      <!-- Desktop Grid -->
      <div class="hidden md:block p-[188px] space-y-64">
        <div v-for="(project, index) in projectsData" :key="index" class="grid grid-cols-12 gap-16">
          <div class="col-span-8 order-2 project-video-container">
            <VideoPlayer :video-src="project.videoSrc" :autoplay="true" :start-muted="true" />
          </div>
          <div class="col-span-4 order-1 project-content">
            <div class="space-y-[-4px]">
              <div class="text-xl font-normal">{{ project.title }}</div>
              <div class="text-xl opacity-35 font-light">{{ project.type }}</div>
            </div>
            <p class="text-gray-200 mt-4 mb-6 text-lg leading-[24px] font-light">
              {{ project.description }}
            </p>
            <div class="text-[11px] leading-[15px] text-white mono tracking-[0.01em] font-light">
              <p class="mb-2">
                <span class="text-[#EDEDED]">CREDITS</span
                ><span class="opacity-40">:</span>
              </p>
              <template v-for="(value, key) in project.credits" :key="key">
                <p>
                  <span class="text-[#EDEDED]">{{ key }}</span
                  ><span class="opacity-40">: {{ value }}</span>
                </p>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
